export const PLAYGROUND_LINK = !import.meta.url.startsWith('http://localhost')
  ? `//ricos.dev`
  : '/app.html';
